"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var MAX_STATS_ALLOWED = 7; // Maximum number of stats allowed

/**
 * The StatsBar component is a horizontal bar that shows some quick stats
 *
 * @param {object} classes Classes
 * @param {object} stats Statistics to show
 * @param {object} styles Customized configurations used by both `styles` and withStyles(), below
 *
 * @returns {object} A React subcomponent
 */
var StatsBar = function StatsBar(_ref) {
  var classes = _ref.classes,
    stats = _ref.stats,
    styles = _ref.styles;
  var countClasses = classes.statCount;
  var iconClasses = classes.statsIcon;
  var titleClasses = classes.statTitle;
  var truncatedListOfStats = stats.slice(0, MAX_STATS_ALLOWED);

  /**
   * An icon for a stat
   *
   * @param {string} alt The alt text
   * @param {string} src The image's source media
   *
   * @returns {object} A React subcomponent
   */
  var StatsBarIcon = function StatsBarIcon(_ref2) {
    var alt = _ref2.alt,
      src = _ref2.src;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: iconClasses
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: src,
      alt: alt
    }));
  };

  /**
   * The title and count for a single stat
   *
   * @param {number} countId DOM id for the count
   * @param {boolean} isTitleFirst Whether to show the title before the count
   * @param {string} title Name of the stat
   * @param {string} titleId DOM id for the title
   * @param {number} val The value to show
   *
   * @param {number} titleId DOM id for the title
   * @returns {object} A React subcomponent
   */
  var StatsBarTitleAndCount = function StatsBarTitleAndCount(_ref3) {
    var countId = _ref3.countId,
      isTitleFirst = _ref3.isTitleFirst,
      title = _ref3.title,
      titleId = _ref3.titleId,
      val = _ref3.val;
    if (isTitleFirst) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: titleClasses,
        id: titleId
      }, title), /*#__PURE__*/_react.default.createElement("div", {
        className: countClasses,
        id: countId
      }, val));
    }
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: countClasses,
      id: countId
    }, val), /*#__PURE__*/_react.default.createElement("div", {
      className: titleClasses,
      id: titleId
    }, title || 0));
  };

  /**
   * A group of things to show for a single stat
   *
   * @param {number} index Numbering assigned to this stats group
   * @param {object} stat Statistic to show
   *
   * @returns {object} A React subcomponent
   */
  var StatsBarGroup = function StatsBarGroup(_ref4) {
    var index = _ref4.index,
      stat = _ref4.stat;
    var countId = "statsbar_count_".concat(index + 1);
    var isTitleFirst = styles.global.statTitleFirst;
    var titleId = "statsbar_title_".concat(index + 1);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.statsGroup
    }, /*#__PURE__*/_react.default.createElement(StatsBarIcon, {
      alt: stat.statIconAlt,
      src: stat.statIconSrc
    }), /*#__PURE__*/_react.default.createElement(StatsBarTitleAndCount, {
      countId: countId,
      isTitleFirst: isTitleFirst,
      title: stat.name,
      titleId: titleId,
      val: stat.val
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.statsSection
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.box
  }, truncatedListOfStats.map(function (stat, index) {
    return /*#__PURE__*/_react.default.createElement(StatsBarGroup, {
      index: index,
      stat: stat
    });
  }))));
};

/**
 * Used by withStyles(), below
 */
var styles = function styles() {
  return {
    statsSection: function statsSection(props) {
      return {
        top: props.styles.global.top ? props.styles.global.top : '139px',
        width: '100%',
        zIndex: 999,
        position: 'fixed',
        background: props.styles.global.background ? props.styles.global.background : '#8DCAFF',
        textAlign: 'center',
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'flex-end'
      };
    },
    box: function box(props) {
      return {
        display: 'inline-flex',
        height: props.styles.global.height ? props.styles.global.height : '47px',
        margin: '0 auto'
      };
    },
    statTitle: function statTitle(props) {
      return props.styles.global && props.styles.global.horizontalStyle ? _objectSpread({
        float: props.styles.statTitle ? props.styles.statTitle.float ? props.styles.statTitle.float : 'left' : 'left',
        color: props.styles.statTitle ? props.styles.statTitle.color ? props.styles.statTitle.color : '#062D4F' : '#062D4F',
        fontFamily: props.styles.statTitle ? props.styles.statTitle.fontFamily ? props.styles.statTitle.fontFamily : 'Nunito' : 'Nunito',
        fontWeight: 600,
        fontSize: props.styles.statTitle ? props.styles.statTitle.fontSize ? props.styles.statTitle.fontSize : '11px' : '11px',
        letterSpacing: '1px',
        margin: '14px 8px 0px 0px',
        textTransform: props.styles.statTitle ? props.styles.statTitle.textTransform ? props.styles.statTitle.textTransform : 'uppercase' : 'uppercase'
      }, props.styles.statTitle) : _objectSpread({
        float: props.styles.statTitle ? props.styles.statTitle.float ? props.styles.statTitle.float : 'left' : 'left',
        color: props.styles.statTitle ? props.styles.statTitle.color ? props.styles.statTitle.color : '#263960' : '#263960',
        fontFamily: props.styles.statTitle ? props.styles.statTitle.fontFamily ? props.styles.statTitle.fontFamily : 'Nunito' : 'Nunito',
        fontSize: props.styles.statTitle ? props.styles.statTitle.fontSize ? props.styles.statTitle.fontSize : '11px' : '11px',
        fontWeight: props.styles.statTitle ? props.styles.statTitle.fontWeight ? props.styles.statTitle.fontWeight : 500 : 500,
        margin: props.styles.statTitle ? typeof props.styles.statTitle.margin !== 'undefined' ? props.styles.statTitle.margin : '6px 0px 0px 15px' : '6px 0px 0px 15px',
        textTransform: props.styles.statTitle ? props.styles.statTitle.textTransform ? props.styles.statTitle.textTransform : 'uppercase' : 'uppercase',
        width: props.styles.statTitle ? props.styles.statTitle.width ? props.styles.statTitle.width : '90px' : '90px',
        textAlign: 'left'
      }, props.styles.statTitle);
    },
    statCount: function statCount(props) {
      return props.styles.global && props.styles.global.horizontalStyle ? _objectSpread({
        display: 'inline-block',
        float: props.styles.statCount ? props.styles.statCount.float ? props.styles.statCount.float : 'left' : 'left',
        color: props.styles.statCount ? props.styles.statCount.color ? props.styles.statCount.color : '#0467BD' : '#0467BD',
        fontFamily: props.styles.statCount ? props.styles.statCount.fontFamily ? props.styles.statCount.fontFamily : 'Oswald' : 'Oswald',
        fontSize: props.styles.statCount ? props.styles.statCount.fontSize ? props.styles.statCount.fontSize : '20px' : '20px',
        margin: props.styles.statCount ? props.styles.statCount.margin ? props.styles.statCount.margin : '6px 0px 0px 0px' : '6px 0px 0px 0px',
        fontWeight: 600
      }, props.styles.statCount) : _objectSpread({
        width: props.styles.statCount ? props.styles.statCount.width ? props.styles.statCount.width : '100%' : '100%',
        textAlign: props.styles.statCount ? props.styles.statCount.textAlign ? props.styles.statCount.textAlign : 'left' : 'left',
        color: props.styles.statCount ? props.styles.statCount.color ? props.styles.statCount.color : '#263960' : '#263960',
        fontFamily: props.styles.statCount ? props.styles.statCount.fontFamily ? props.styles.statCount.fontFamily : 'Oswald' : 'Oswald',
        fontSize: props.styles.statCount ? props.styles.statCount.fontSize ? props.styles.statCount.fontSize : '20px' : '20px',
        margin: props.styles.statCount ? props.styles.statCount.margin ? props.styles.statCount.margin : '6px 0px 0px 0px' : '6px 0px 0px 0px',
        float: props.styles.statCount ? props.styles.statCount.float ? props.styles.statCount.float : 'none' : 'none',
        fontWeight: 600
      }, props.styles.statCount);
    },
    statsGroup: function statsGroup(props) {
      return props.styles.global && props.styles.global.horizontalStyle ? {
        // spacing between stats
        margin: props.styles.statsGroup ? props.styles.statsGroup.margin ? props.styles.statsGroup.margin : '4px 32px' : '4px 32px'
      } : {
        margin: props.styles.statsGroup ? props.styles.statsGroup.margin ? props.styles.statsGroup.margin : '4px 0px' : '4px 0px',
        padding: props.styles.statsGroup ? props.styles.statsGroup.padding ? props.styles.statsGroup.padding : '4px 40px 10px 60px' : '4px 40px 10px 60px',
        borderRight: props.styles.statsGroup ? props.styles.statsGroup.borderRight ? props.styles.statsGroup.borderRight : '4px solid #0B3556' : '4px solid #0B3556',
        minWidth: '180px',
        maxWidth: '185px',
        '&:first-child': {
          minWidth: '190px',
          maxWidth: '225px',
          padding: props.styles.statsGroup ? props.styles.statsGroup['&:first-child'] && props.styles.statsGroup['&:first-child'].padding ? props.styles.statsGroup['&:first-child'].padding : '6px 20px 10px 90px' : '6px 20px 10px 90px'
        },
        '&:last-child': {
          borderRight: 'none',
          minWidth: '205px',
          maxWidth: '225px',
          padding: props.styles.statsGroup ? props.styles.statsGroup['&:last-child'] && props.styles.statsGroup['&:last-child'].padding ? props.styles.statsGroup['&:last-child'].padding : '4px 40px 10px 80px' : '4px 40px 10px 80px'
        }
      };
    },
    statsIcon: function statsIcon(props) {
      return _objectSpread({
        position: 'absolute',
        float: 'left',
        width: props.styles.statsIcon ? props.styles.statsIcon.width ? props.styles.statsIcon.width : '28px' : '28px',
        height: props.styles.statsIcon ? props.styles.statsIcon.height ? props.styles.statsIcon.height : '28px' : '28px',
        margin: props.styles.statsIcon ? props.styles.statsIcon.margin ? props.styles.statsIcon.margin : '8px 0px 0px -35px' : '8px 0px 0px -35px'
      }, props.styles.statsIcon);
    }
  };
};
StatsBar.defaultProps = {
  classes: {},
  styles: {}
};

// TODO: need to change it to injectStyle sheet
var StyledStatsBar = (0, _core.withStyles)(styles)(StatsBar);
var _default = StyledStatsBar;
exports.default = _default;